import Vue from 'vue'
import { chatApi, presetApi } from '@/api'

/**
 * 全局对话状态。
 * 首页「AI 问答助手」标签与右下角悬浮窗共用同一份会话，
 * 这样在任意入口提问都不会丢上下文。
 */
export const chatState = Vue.observable({
  messages: [],
  presets: [],
  lastHit: null,
  online: true,
  sending: false
})

let presetsReady = false

export function ensureWelcome() {
  if (chatState.messages.length) return
  chatState.messages.push({
    role: 'bot',
    text: '您好，我是 润得科技智能问答系统助手。您可以问我设备使用、平台操作、功能说明等问题；也可以切换到「检索知识库文章」标签直接查文章。'
  })
}

export async function loadPresets() {
  if (presetsReady) return chatState.presets
  presetsReady = true
  try {
    const res = await presetApi.list()
    chatState.presets = res.data || []
  } catch (e) {
    presetsReady = false
  }
  return chatState.presets
}

export function setOnline(v) {
  chatState.online = !!v
}

/**
 * 发送问题并流式更新消息（供所有入口复用）
 * @param {string} rawQ 问题文本
 * @param {Function} onTick 消息更新回调（用于滚动到底部）
 * @returns {Promise<{ok: boolean, msg?: string}>}
 */
export async function sendQuestion(rawQ, onTick) {
  const q = (rawQ || '').trim()
  if (!chatState.online) return { ok: false, msg: '网络断开中，重连后可继续' }
  if (!q) return { ok: false }
  if (!q.replace(/[？?。.！!，,]/g, '')) {
    return { ok: false, msg: '请输入有效的问题内容' }
  }
  if (chatState.sending) return { ok: false }

  chatState.sending = true
  chatState.messages.push({ role: 'me', text: q })
  const botIdx = chatState.messages.length
  chatState.messages.push({
    role: 'bot',
    thinking: true,
    html: '<span class="typing"><i></i><i></i><i></i></span>'
  })
  if (onTick) onTick()

  try {
    let streamed = ''
    const res = await chatApi.ask(q, { lastHit: chatState.lastHit }, (delta) => {
      streamed += delta
      chatState.messages.splice(botIdx, 1, { role: 'bot', text: streamed, question: q })
      if (onTick) onTick()
    })
    const data = res.data || {}
    if (data.hitId) chatState.lastHit = data.hitId
    const suggest = (data.type === 'reject' || data.type === 'miss')
      ? chatState.presets.slice(0, 4).map(p => p.q)
      : []
    chatState.messages.splice(botIdx, 1, {
      role: 'bot',
      text: data.text,
      question: q,
      reject: data.type === 'reject',
      building: data.type === 'building',
      askRecordId: data.askRecordId,
      conversationId: data.conversationId || '',
      suggest,
      showFeedback: data.type !== 'miss' || !!data.askRecordId
    })
    if (onTick) onTick()
    // 接口或流失败（failed 标记）：ok:false，调用方会把输入内容回填，方便用户重发
    return { ok: !data.failed }
  } catch (e) {
    chatState.messages.splice(botIdx, 1, {
      role: 'bot',
      text: '服务器繁忙，请刷新后重试',
      question: q
    })
    if (onTick) onTick()
    // 请求失败：返回 ok:false，调用方会把输入内容回填，方便用户重发
    return { ok: false }
  } finally {
    chatState.sending = false
  }
}
